import * as S from './PageTemplate.styled';
import { useEffect } from 'react';
import useNav from '../../../application/hooks/useNav';

interface IPageTemplate {
  children: React.ReactNode;
  hideHeader?: string;
}

const PageTemplateKt = (props: IPageTemplate) => {
  const { historyBack } = useNav();

  useEffect(() => {
    window.onClickHWKeyBtn = () => {
      historyBack();
    };
  }, [historyBack]);
  return (
    <>
      <S.PageTemplate>{props.children}</S.PageTemplate>
    </>
  );
};

export default PageTemplateKt;
